import { EventBus, EventMap, getEventBus, useEventBus } from "@cirrus/core/events"

export interface CommonEventBus extends EventMap {

  "App > GlobalSettings > Fetch": () => void;
  "App > UserSettings > InitFromCache": () => void;
  "App > UserSettings > InitFromCache > Success": (data: any) => void;
  "App > UserSettings > Fetch": () => void;
  "App > UserSettings > Fetch > Success": (data: any) => void;
  "App > UserSettings > Fetch > Error": () => void;
}

export const useCommonEventBus = () => {
  return  useEventBus() as EventBus<CommonEventBus>
}

export function getCommonEventBus() {
  return getEventBus() as EventBus<CommonEventBus>
}
